// extracted by mini-css-extract-plugin
module.exports = {"box":"PopupContentDynamic_box__2LXTy","button":"PopupContentDynamic_button__3HrDN"};